<template>
  <div class="components-key-value">
    <p class="label fl" :class="{'shallow-label':labelShallow}" :style="labelStyle">{{label}}</p>
    <p class="fl" ref="separate">{{separate || '&nbsp;&nbsp;&nbsp;'}}</p>
    <p class="value fl" ref="value"><slot></slot></p>
  </div>
</template>
<style lang="scss" scoped>
  @import "key-value.theme";
  .components-key-value{
    line-height:$key-value-line-height;
    font-size: $key-value-font-size;
    width:100%;
    overflow: hidden;
    .shallow-label{
      color:$key-value-label-color;
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/key-value/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/key-value/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/key-value/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-key-value')
  export default {
    name: 'base-key-value', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-key-value': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>